import { createElement } from "react";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Typography, MenuItem, Select } from "@mui/material";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Vessel_FerryEuClass_get_All, Vessel_FerryEuClass_TryFromId_Z721C83C5, Vessel_FerryEuClass__get_Id, Vessel_NavigationArea_get_All, Vessel_NavigationArea_TryFromId_Z721C83C5, Vessel_NavigationArea__get_Id, Vessel_Cert_get_All, Vessel_certWithTypePrint, Vessel_Cert_TryFromId_Z721C83C5, Vessel_Cert__get_Id, Vessel_Type_get_All, Vessel_Type_TryFromString_Z721C83C5, Vessel_Type__get_Id } from "../Shared/Shared.js";
import { append, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { simpleCaption, Vessel_ToggleFavoriteButton, responsiveCard } from "../ViewHelpers.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

/**
 * Render one vessel type select for legacy vessel type and one for the new type.
 * Background colors indicate which is new and old
 */
export function typeSelect(vesselType, onTypeChange) {
    let elems_1, elements, array_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 0.5 + "rem",
    }], (elems_1 = [MuiHelpers_createElement(Select, [["style", {
        minWidth: 100,
        textAlign: "left",
    }], ["variant", "outlined"], ["value", defaultArg(map(toString, vesselType), "empty")], ["onChange", (delegateArg, delegateArg_1) => {
        onTypeChange(defaultArg(map(Vessel_Type__get_Id, Vessel_Type_TryFromString_Z721C83C5(delegateArg_1.props.value)), -1));
    }], (elements = ((array_2 = map_1((type$0027) => MuiHelpers_createElement(MenuItem, [["value", toString(type$0027)], ["children", toString(type$0027)]]), Vessel_Type_get_All()), append([MuiHelpers_createElement(MenuItem, [["value", "empty"], ["children", "Ukjent"]])], array_2))), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function oldTypeSelect(oldVesselTypeId, oldOptions, onOldTypeChange) {
    let elems_1, elements;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 0.5 + "rem",
    }], (elems_1 = [MuiHelpers_createElement(Select, [["style", {
        minWidth: 100,
        textAlign: "left",
    }], ["variant", "outlined"], ["value", defaultArg(map(int32ToString, oldVesselTypeId), "empty")], ["onChange", (e, _arg) => {
        onOldTypeChange(e.target.value);
    }], (elements = [MuiHelpers_createElement(MenuItem, [["value", "empty"], ["children", "Ukjent"]]), map_1((tupledArg) => {
        const e_1 = tupledArg[2];
        return MuiHelpers_createElement(MenuItem, toList(delay(() => append_1(singleton(["value", tupledArg[0]]), delay(() => append_1(singleton(["children", tupledArg[1]]), delay(() => append_1(singleton(["hidden", !e_1]), delay(() => (!e_1 ? singleton(["style", {
            display: "none",
        }]) : empty()))))))))));
    }, oldOptions)], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function certSelect(vesselType, onChange, vesselCertificate) {
    let elements, array_2;
    return MuiHelpers_createElement(Select, [["style", {
        minWidth: 100,
        textAlign: "left",
    }], ["variant", "outlined"], ["value", defaultArg(map(Vessel_Cert__get_Id, vesselCertificate), "empty")], ["onChange", (delegateArg, delegateArg_1) => {
        onChange(Vessel_Cert_TryFromId_Z721C83C5(delegateArg_1.props.value));
    }], (elements = ((array_2 = map_1((cert_1) => MuiHelpers_createElement(MenuItem, [["value", Vessel_Cert__get_Id(cert_1)], ["children", Vessel_certWithTypePrint(vesselType, cert_1)]]), Vessel_Cert_get_All()), append([MuiHelpers_createElement(MenuItem, [["value", "empty"], ["children", "Ukjent"]])], array_2))), ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

/**
 * Render one navigation area select for legacy vessel type and one for the new type.
 * Background colors indicate which is new and old
 */
export function navigationAreaSelect(navArea, onAreaChange) {
    let elems_1, elements;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 0.5 + "rem",
    }], (elems_1 = [MuiHelpers_createElement(Select, [["style", {
        minWidth: 100,
        textAlign: "left",
    }], ["variant", "outlined"], ["value", defaultArg(map(Vessel_NavigationArea__get_Id, navArea), "empty")], ["onChange", (delegateArg, delegateArg_1) => {
        onAreaChange(Vessel_NavigationArea_TryFromId_Z721C83C5(delegateArg_1.props.value));
    }], (elements = [MuiHelpers_createElement(MenuItem, [["value", "empty"], ["children", "Ukjent"]]), map_1((area_1) => MuiHelpers_createElement(MenuItem, [["value", Vessel_NavigationArea__get_Id(area_1)], ["children", toString(area_1)]]), Vessel_NavigationArea_get_All())], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

/**
 * Render one navigation area select for legacy vessel type and one for the new type.
 * Background colors indicate which is new and old
 */
export function oldNavigationAreaSelect(oldNavAreaId, oldOptions, onOldAreaChange) {
    let elems_1, elements;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 0.5 + "rem",
    }], (elems_1 = [MuiHelpers_createElement(Select, [["style", {
        minWidth: 100,
        textAlign: "left",
    }], ["variant", "outlined"], ["value", defaultArg(map(int32ToString, oldNavAreaId), "empty")], ["onChange", (e, _arg) => {
        onOldAreaChange(e.target.value);
    }], (elements = [MuiHelpers_createElement(MenuItem, [["value", "empty"], ["children", "Ukjent"]]), map_1((tupledArg) => {
        const e_1 = tupledArg[2];
        return MuiHelpers_createElement(MenuItem, toList(delay(() => append_1(!e_1 ? singleton(["style", {
            display: "none",
        }]) : empty(), delay(() => append_1(singleton(["value", tupledArg[0]]), delay(() => append_1(singleton(["hidden", !e_1]), delay(() => singleton(["children", tupledArg[1]]))))))))));
    }, oldOptions)], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ferryEuClassSelect(onChange, currentOpt) {
    let elems, array_2;
    return MuiHelpers_createElement(Select, [["style", {
        minWidth: 100,
        textAlign: "left",
    }], ["variant", "outlined"], ["value", defaultArg(map(Vessel_FerryEuClass__get_Id, currentOpt), "empty")], ["onChange", (delegateArg, delegateArg_1) => {
        onChange(Vessel_FerryEuClass_TryFromId_Z721C83C5(delegateArg_1.props.value));
    }], (elems = ((array_2 = map_1((euClass_1) => MuiHelpers_createElement(MenuItem, [["value", Vessel_FerryEuClass__get_Id(euClass_1)], ["children", toString(euClass_1)]]), Vessel_FerryEuClass_get_All()), append([MuiHelpers_createElement(MenuItem, [["value", "empty"], ["children", "Ukjent"]])], array_2))), ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

export function responsiveVesselCard(styles, x, route, companyName, readOnly, onUpdate) {
    let matchValue;
    return responsiveCard(styles, RouterModule_encodeParts(ofArray(["vessels", int32ToString(x.Id), "info"]), 1), `Bilde av fartøyet ${x.Name}`, (matchValue = x.MainImageId, (matchValue != null) ? (`/api/vessel/image/${matchValue}/thumbnail`) : "/images/DefaultFerrySmaller.svg"), toList(delay(() => {
        let elems;
        return append_1(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }], (elems = toList(delay(() => append_1(singleton(MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", x.Name]])), delay(() => (!readOnly ? singleton(createElement(Vessel_ToggleFavoriteButton, {
            vesselId: x.Id,
            favorite: x.IsFavorite,
            onUpdate: onUpdate,
        })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(singleton(simpleCaption(toString(x.Status))), delay(() => append_1(singleton(simpleCaption(x.CallSign)), delay(() => append_1(singleton(simpleCaption(companyName)), delay(() => {
            const matchValue_1 = route;
            if (matchValue_1 != null) {
                return singleton(simpleCaption(`${matchValue_1.Name}`));
            }
            else {
                return empty();
            }
        }))))))));
    })));
}

//# sourceMappingURL=VesselHelpers.js.map
